import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../SdsIcon/SdsIcon.vue.js';
import __vue_component__$1 from '../SdsButton/SdsButton.vue.js';

var script = defineComponent({
    name: 'SdsTypeSwitcher',
    emits: ['click'],
    props: {
        types: {
            type: Array,
            required: true,
        },
        selected: {
            type: [String, Number],
            required: false,
            default: null,
        },
    },
    setup: function (_, _a) {
        var emit = _a.emit;
        var onClick = function (item) {
            if (item.disabled) {
                return;
            }
            emit('click', item.type);
        };
        return {
            onClick: onClick,
        };
    },
    components: {
        SdsIcon: __vue_component__,
        SdsButton: __vue_component__$1,
    },
});

export default script;
